export enum EntityType {
    Individual = 1, // Физическое лицо
    Entrepreneur = 3, // Индивидуальный предприниматель
    InternalStudent = 5, // Внутренний студент
    ExternalStudent = 9, // Внешний студент
    UniversityEmployee = 17, // Сотрудник университета
    Servant = 33, // Служащий
    SelfEmployed = 65, // Самозанятый
    LegalEntity = 512, // Юридическое лицо
}
